(function(angular){
	'use strict';
	
	angular
		.module('additionalInvestmentSuccessModule', [
			'apiModule',
			'collapseModule',
			'coreModule',
			'serviceLevelModule',
			'videoModule'
		]);
	
})(window.angular);